import React from "react";
import { Button, ButtonGroup, Grid } from "@material-ui/core";
import styles from "./ListProductGroupingsPage.module.scss";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PagePlaceholder } from "../../../components/page-placeholder/PagePlaceholder";
import SimpleTable from "../../../components/table/Table";
import { removeGroups, getGroups, getGroup, addGroup } from "../../../state/actions/GroupActions";
import { getIcon } from "../../../icon/icon";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import { Loading } from "../../../components/loading/Loading";
import { NewEntityDialog } from "../../../containers/new-entity-dialog/NewEntityDialog";
import { UUID } from "../../../helpers/uuid";
import PageContainer from "../../../components/page-container/PageContainer";
import Search from "../../../components/search/Search";
import { withTranslation } from "react-i18next";
import { getProductGroupDefaultType } from "../../../state/constants/ProductGroupDefaultType";

class ListProductGroupingsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newTagText: "",
      addTagModalOpen: false,
      originalData: [],
      searchedData: [],
      loading: false,
      tags: {},
      selectedGroupIds: [],
      deleteAlertShowing: false,
      newProductGroupDialogShowing: false,
      groups: props.group
    };
  }

  checkDefault(id) {
    const defaultGroups = getProductGroupDefaultType()
    return defaultGroups[id] != null;
  }

  componentDidMount() {
    this.setupData();
  }

  componentDidUpdate() {
    if (JSON.stringify(this.props.groups) !== JSON.stringify(this.state.groups)) {
      const data = this.createData(this.props.groups);

      this.setState({
        originalData: data,
        searchedData: data,
        groups: this.props.groups
      });
    }
  }

  setupData() {
    this.setState({
      loading: true
    });

    this.props.getGroups(() => {
      const data = this.createData(this.props.groups);

      this.setState({
        loading: false,
        originalData: data,
        searchedData: data,
        groups: this.props.groups
      });
    });

  }

  createData(groups) {
    const groupsKeys = Object.keys(groups);

    return groupsKeys.map(groupKey => {
      const group = groups[groupKey];

      return {
        groupId: group.id,
        name: group.Name
      };
    });
  }

  createHeaders() {
    return [
      {
        id: "name",
        clickable: true,
        action: { path: "/product-groupings/{id}", identifier: "groupId" },
        align: "left",
        label: this.props.t('product-group.group-name')
      },
      {
        id: "groupId",
        clickable: false,
        align: "left",
        label: this.props.t('product-group.group-id')
      }
    ];
  }

  createCells(headers) {
    let cells = [];

    headers.forEach(header => {
      let cell = {};

      cell.id = header.id;

      if (header.hasOwnProperty("action")) {
        cell.handleClick = (event, row) => {
          let path = header.action.path.replace(
            "{id}",
            row[header.action.identifier]
          );
          this.props.history.push(path);
        };
      }

      cell.align = header.align;
      cell.clickable = header.clickable;

      cells.push(cell);
    });

    return cells;
  }

  renderData() {
    const headers = this.createHeaders();
    const cells = this.createCells(headers);

    if (this.state.searchedData.length === 0) {
      return (
        <PagePlaceholder
          image={getIcon("grid-alt.svg")}
          text={this.props.t('product-group.none-found')}
        />
      );
    } else {
      return (
        <SimpleTable
          handleSelection={selectedIds => {
            this.setState({ selectedGroupIds: selectedIds });
          }}
          isSelectable={true}
          dataId={"groupId"}
          cells={cells}
          headers={headers}
          rows={this.state.searchedData}
          checkDefault={id => this.checkDefault(id)}
        />
      );
    }
  }

  deleteSelection() {
    this.props.removeGroups(this.state.selectedGroupIds, () => {
      this.setState({ deleteAlertShowing: false, selectedGroupIds: [] });
    });
  }

  render() {

    return (
      <div>
        <NewEntityDialog
          dialogTitle={this.props.t('product-group.add-product-group')}
          confirmLabel={this.props.t('product-group.add-product-group')}
          isOpen={this.state.newProductGroupDialogShowing}
          onCancel={() =>
            this.setState({ newProductGroupDialogShowing: false, newProductGroupTitle: '' })
          }
          onTitleChange={value =>
            this.setState({ newProductGroupTitle: value })
          }
          title={this.state.newProductGroupTitle}
          onConfirm={() => {
            this.props.addGroup(
              { Name: this.state.newProductGroupTitle, id: UUID() },
              () => {
                this.setState({ newProductGroupDialogShowing: false, newProductGroupTitle: '' });
              }
            );
          }}
        />

        <AlertDialog
          title={this.props.t('common.remove-question')}
          description={this.props.t('common.remove-description')}
          options={[
            {
              label: this.props.t('common.cancel'),
              action: () => this.setState({ deleteAlertShowing: false })
            },
            { label: this.props.t('common.delete'), action: () => this.deleteSelection() }
          ]}
          isOpen={this.state.deleteAlertShowing}
        />

        <HeaderBlock
          title={this.props.t('product-group.product-groupings')}
          right={
            <Grid container spacing={2} alignItems="center" justify="flex-end" wrap="nowrap">
              <Grid item zeroMinWidth>
                <Search
                  searchField={"name"}
                  secondaryFields={["groupId"]}
                  returnSearchMatches={data => {
                    this.setState({ searchedData: data });
                  }}
                  data={this.state.originalData}
                  searchTitle={this.props.t('product-group.search')}
                />
              </Grid>
              <Grid item zeroMinWidth>
                <ButtonGroup>
                  <Button
                    disabled={this.state.selectedGroupIds.length < 1}
                    onClick={() => this.setState({ deleteAlertShowing: true })}
                    variant="outlined"
                    color="primary"
                  >
                    {this.props.t('common.delete')}
                  </Button>
                  <Button
                    onClick={() =>
                      this.setState({ newProductGroupDialogShowing: true })
                    }
                    variant="outlined"
                    color="secondary"
                  >
                    {this.props.t('product-group.new-grouping')}
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>

          }
        />

        <PageContainer hasFooter>
          {this.state.loading ? <Loading /> : this.renderData()}
        </PageContainer>
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { groups } = state.GroupReducer;
  return { groups };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ removeGroups, getGroups, getGroup, addGroup }, dispatch);

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ListProductGroupingsPage))
);

// EXPORT COMPONENT

export { hoc as ListProductGroupingsPage };
